import { ButtonModule } from 'primeng/button';

import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ExternalLinksConstants } from '@web/csl-lib-constants';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'csl-login-home',
  imports: [RouterModule, ButtonModule],
  templateUrl: './login-home.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './login-home.component.css',
})
export class LoginHomeComponent {
  protected readonly ExternalLinksConstants = ExternalLinksConstants;
  readonly router = inject(Router)

  onClickLogin() {
    this.router.navigate(['dashboard']);
  }
}
